import { supabase } from './client';

export async function createSet(matchId: string, setNumber: number) {
  const { data, error } = await supabase
    .from('sets')
    .insert({
      match_id: matchId,
      set_number: setNumber,
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function updateSetServingState(setId: string, servingTeamId: string, serverId: string | null) {
  const { error } = await supabase
    .from('sets')
    .update({
      current_serving_team_id: servingTeamId,
      current_server_id: serverId || null,
    })
    .eq('id', setId);
  if (error) throw error;
}

export async function updateSet(setId: string, updateData: {
  scoreA?: number;
  scoreB?: number;
  winnerId?: string | null;
  endedAt?: string | null;
}) {
  const { data, error } = await supabase
    .from('sets')
    .update({
      score_a: updateData.scoreA,
      score_b: updateData.scoreB,
      winner_id: updateData.winnerId,
      ended_at: updateData.endedAt,
    })
    .eq('id', setId)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function getSetsByMatch(matchId: string) {
  const { data, error } = await supabase
    .from('sets')
    .select('*')
    .eq('match_id', matchId)
    .order('set_number');

  if (error) throw error;
  return data;
}

export async function getSetByMatchAndNumber(matchId: string, setNumber: number) {
  const { data, error } = await supabase
    .from('sets')
    .select('*')
    .eq('match_id', matchId)
    .eq('set_number', setNumber)
    .maybeSingle();

  if (error) throw error;
  return data;
}

// --- Side Change Tracking ---

export async function updateSetSideChange(setId: string, sideChangeShown: boolean) {
  const { error } = await supabase
    .from('sets')
    .update({ side_change_shown: sideChangeShown })
    .eq('id', setId);

  if (error) throw error;
}
